import React from 'react'
import type { ModalProps } from '@/interface/common.interface'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"

const CommonModal: React.FC<ModalProps> = ({ title, show, onClose, className = "sm:max-w-2xl max-w-2xl", children }) => {
    return (
        <Dialog open={show} onOpenChange={onClose} >
            <DialogContent className={`overflow-y-auto overflow-x-hidden max-h-[90vh] ${className}`}  >
                {title ? (
                    <DialogHeader>
                        <DialogTitle>{title}</DialogTitle>
                    </DialogHeader>
                ) : null}
                {children}
            </DialogContent>
        </Dialog>
    )
}

export default CommonModal